import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import PersonIcon from '@material-ui/icons/Person';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import './NavbarTextil.scss';
import LogoContainer from 'containers/LogoContainer';

const NavBarTextil = (
  { cartSize, categories, closeMenu, isMenuActive, isUserLoggedIn, logout, openLoginModal,
    openMenu, openSearchModal, user, show, client, subCategories }
  ) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="textil-nav">
      <nav className="textil-navbar">
        <div className="textil-inner">
          {/* hamburguesa */}
          <button
            className="textil-hamburger"
            aria-label="toggle menu"
            onClick={() => setOpen(!open)}
          >
            {open ? <CloseIcon fontSize="large"/> : <MenuIcon fontSize="large"/>}
          </button>

          {/* logo */}
          <Link to="/" className="textil-logo">
            <LogoContainer />
          </Link>

          {/* links */}
          <ul className="textil-links">
            <li><Link to="/home">Inicio</Link></li>
            <li><Link to="/productos">Productos</Link></li>
            <li><Link to="/ofertas">Ofertas</Link></li>
          </ul>

          {/* acciones */}
          <div className="textil-actions">
            <a className="textil-action" role="presentation" onClick={openSearchModal}>
              <i className="fa fa-search" aria-hidden="true" />
            </a>
            {!user
              ? (
                <div className="navbar-icon" role="presentation" onClick={openLoginModal}>
                  <i className="fa fa-sign-in" aria-hidden="true" />
                </div>
              )
              : (
                <li>
                  <div className="navbar-icon" role="presentation">
                    <div className="dropdown">
                      <i className="fa fa-user" aria-hidden="true" />
                      <div className="dropdown-content">
                        <NavLink className="top-nav-item top-nav-border-right" to="/perfil">
                          <i className="fa fa-user" aria-hidden="true" />
                          {' '}
                          Mi cuenta
                        </NavLink>
                        <NavLink to="/compras" className="top-nav-item top-nav-border-right" data-testid="nav-purchases">
                          Mis compras
                        </NavLink>
                        <a href={() => false} onClick={logout}>Cerrar sesi&oacute;n</a>
                      </div>
                    </div>
                  </div>
                </li>
              )}
            <Link to="/carrito" className="textil-action textil-cart">
              <ShoppingCartIcon />
              {cartSize > 0 && <span className="textil-badge">{cartSize}</span>}
            </Link>
          </div>
        </div>
      </nav>

      {/* overlay */}
      {open && <div className="textil-overlay" onClick={() => setOpen(false)} />}

      {/* drawer (mobile) */}
      <div className={`textil-drawer${open ? ' open' : ''}`}>
        <ul>
          <li><Link to="/productos" onClick={() => setOpen(false)}>Productos</Link></li>
          <li><Link to="/categorias" onClick={() => setOpen(false)}>Categorías</Link></li>
          <li><Link to="/ofertas" onClick={() => setOpen(false)}>Ofertas</Link></li>
          <li><Link to="/muestrarios" onClick={() => setOpen(false)}>Muestrarios</Link></li>
        </ul>
      </div>
    </div>
  );
};

export default NavBarTextil;
